/**
 * Code Block — copy to clipboard
 *
 * Highlighting is handled by Bricks' own `bricksPrettify()`; this file only adds
 * the copy button behaviour.
 *
 * Click handling is delegated from the document rather than bound per button:
 * Bricks replaces element nodes on every edit in the builder, and query loops /
 * AJAX pagination swap them on the front end. Delegation survives all of that
 * and stays idempotent no matter how often Bricks re-runs the init.
 *
 * Note: gulp wraps this bundle in an IIFE, so anything Bricks has to reach via
 * the `$scripts` property must be assigned onto `window`.
 */

var MAD_CODE_RESET_DELAY = 2000;

/**
 * Clipboard write with a fallback.
 *
 * `navigator.clipboard` only exists in secure contexts — a plain-http staging or
 * local domain would otherwise leave the button dead, so fall back to the old
 * hidden-textarea trick there.
 */
function madCodeWriteClipboard(text) {
    if (window.navigator && navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text);
    }

    return new Promise(function (resolve, reject) {
        var textarea = document.createElement("textarea");

        textarea.value = text;
        textarea.setAttribute("readonly", "");
        textarea.style.position = "fixed";
        textarea.style.top = "-9999px";
        textarea.style.opacity = "0";

        document.body.appendChild(textarea);
        textarea.select();

        try {
            if (document.execCommand("copy")) {
                resolve();
            } else {
                reject();
            }
        } catch (e) {
            reject(e);
        }

        document.body.removeChild(textarea);
    });
}

function madCodeFeedback(button, copied) {
    var textNode = button.querySelector(".mad-code__copy-text");
    var label = copied
        ? button.getAttribute("data-copied-label")
        : button.getAttribute("data-copy-label");

    if (textNode && label) {
        textNode.textContent = label;
    }

    button.classList.toggle("is-copied", copied);
}

function madCodeCopy(button) {
    var root = button.closest(".mad-code");
    var code = root ? root.querySelector(".mad-code__pre code") : null;

    if (!code) {
        return;
    }

    // `textContent` of the <code> is the original source: Prettify only wraps
    // ranges in <span>s, it never rewrites the characters.
    madCodeWriteClipboard(code.textContent).then(
        function () {
            madCodeFeedback(button, true);

            window.clearTimeout(button.madCodeTimer);
            button.madCodeTimer = window.setTimeout(function () {
                madCodeFeedback(button, false);
            }, MAD_CODE_RESET_DELAY);
        },
        function () {
            // Copying failed (permission denied, no clipboard) — leave the button
            // in its resting state rather than claiming success.
        }
    );
}

function madCodeOnClick(event) {
    // Guard: clicks can land on non-element targets (document, text nodes).
    if (!event.target || typeof event.target.closest !== "function") {
        return;
    }

    var button = event.target.closest(".mad-code__copy");

    if (button) {
        madCodeCopy(button);
    }
}

function initMadCode() {
    if (document.madCodeBound) {
        return;
    }

    document.madCodeBound = true;
    document.addEventListener("click", madCodeOnClick);
}

// Exposed for Bricks' `$scripts` property.
window.initMadCode = initMadCode;

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initMadCode);
} else {
    initMadCode();
}
